<!-- Map messageType to FontAwesome classes matching html-popup-helper.ts => _getWarningIconClass() -->
@switch (messageType()) {
    @case (1) {
      <i class="fa fa-id-badge" aria-hidden="true"></i>
    }
    @case (2) {
      <i class="fa fa-battery-quarter" aria-hidden="true"></i>
    }
    @case (3) {
      <i class="far fa-clock" aria-hidden="true"></i>
    }
    @case (5) {
      <i class="fab fa-product-hunt" aria-hidden="true"></i>
    }
    @case (7) {
      <i class="fas fa-ban" aria-hidden="true"></i>
    }
    @case (8) {
      <i class="fas fa-route" aria-hidden="true"></i>
    }
    @case (9) {
      <i class="fa-solid fa-business-time" aria-hidden="true"></i>
    }
    @default {
      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
    }
  }